import { useEffect, useState } from "react";
import { request } from "../../../../network/Request";
import Filter from "../../../../components/Filter/Filter.js";
import { getRank } from "../../../../utils/rankUtils";

const Personal = ({ matchType }) => {
  const [rankedPlayers, setRankedPlayers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const distances = ["145", "90", "70", "30"];

  useEffect(() => {
    // 모든 거리 × 성별의 데이터를 병렬로 가져오기
    const fetchAllData = async () => {
      const promises = [];

      // 각 거리별로 남자, 여자 데이터 요청
      distances.forEach((distance) => {
        promises.push(
          request({
            "bk-working": "score-list",
            type: "PRE",
            distance: distance,
            gender: "M",
          })
        );
        promises.push(
          request({
            "bk-working": "score-list",
            type: "PRE",
            distance: distance,
            gender: "F",
          })
        );
      });

      try {
        const results = await Promise.all(promises);

        // 각 거리별 데이터 처리 (남녀 통합)
        const distanceData = {};
        const maxScores = {}; // 각 거리별 최고 점수 (남녀 통합)

        distances.forEach((distance, distIndex) => {
          const maleResult = results[distIndex * 2]; // 남자 데이터
          const femaleResult = results[distIndex * 2 + 1]; // 여자 데이터

          let allPlayers = [];

          // 남자 데이터 처리
          if (maleResult.result && maleResult.response.score_array) {
            const maleArray = maleResult.response.score_array;
            maleArray.forEach((item) => {
              let total = 0;
              const scoreArr = item.score_concat.split(",");
              scoreArr.forEach((score) => {
                total += parseInt(score);
              });
              item.total = total;
              allPlayers.push(item);
            });
          }

          // 여자 데이터 처리
          if (femaleResult.result && femaleResult.response.score_array) {
            const femaleArray = femaleResult.response.score_array;
            femaleArray.forEach((item) => {
              let total = 0;
              const scoreArr = item.score_concat.split(",");
              scoreArr.forEach((score) => {
                total += parseInt(score);
              });
              item.total = total;
              allPlayers.push(item);
            });
          }

          distanceData[distance] = allPlayers;

          // 해당 거리의 최고 점수 찾기 (남녀 통합)
          if (allPlayers.length > 0) {
            maxScores[distance] = Math.max(...allPlayers.map((p) => p.total));
          }
        });

        // 선수별로 데이터 통합 및 백분위 계산
        const playerMap = {};

        Object.keys(distanceData).forEach((distance) => {
          distanceData[distance].forEach((player) => {
            const key = player.player_number + "-" + player.gender; // 성별 포함하여 고유 키 생성

            if (!playerMap[key]) {
              playerMap[key] = {
                playerNo: player.player_number,
                country: player.country,
                name: player.player_name,
                gender: player.gender,
                percentileScores: { "145M": 0, "90M": 0, "70M": 0, "30M": 0 },
                total: 0,
              };
            }

            // 백분위 계산: (자신의 득점 / 해당 거리 최고점) × 100
            const percentile =
              maxScores[distance] > 0
                ? (player.total / maxScores[distance]) * 100
                : 0;

            playerMap[key].percentileScores[distance + "M"] =
              Math.round(percentile * 100) / 100;
            playerMap[key].total += percentile;
          });
        });

        // 총점 기준 정렬 (남녀 통합 순위)
        const sorted = Object.values(playerMap)
          .map((player) => ({
            ...player,
            total: Math.round(player.total * 100) / 100,
          }))
          .sort((a, b) => b.total - a.total);

        setRankedPlayers(sorted);
        setFiltered(sorted);
        console.log("Ranked Players (Male + Female):", sorted);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllData();
  }, [matchType]);

  const handleSearch = (filters) => {
    let filtered = [...rankedPlayers];

    if (filters.country) {
      filtered = filtered.filter((p) => p.country === filters.country);
    }
    if (filters.playerName) {
      filtered = filtered.filter((p) =>
        p.name?.toLowerCase().includes(filters.playerName.toLowerCase())
      );
    }
    if (filters.gender) {
      filtered = filtered.filter((p) => p.gender === filters.gender);
    }

    setFiltered(filtered);
  };

  return (
    <>
      <div className="table-box box-1 margin-table">
        <div className="table-wrap result-table">
          <div className="table-shadow">
            {filtered.length !== 0 && <Filter onSearch={handleSearch} />}
            <table>
              <colgroup>
                <col width="5%" />
                <col width="5%" />
              </colgroup>
              <thead>
                <tr>
                  <th rowSpan="2">Rank</th>
                  <th rowSpan="2">Player No.</th>
                  <th rowSpan="2">Country</th>
                  <th rowSpan="2">Player Name</th>
                  <th rowSpan="2">Gender</th>
                  <th colSpan="4">Event (Percentile Score)</th>
                  <th rowSpan="2">Total</th>
                </tr>
                <tr>
                  <th>145M</th>
                  <th>90M</th>
                  <th>70M</th>
                  <th>30M</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((player, index) => {
                  const rank = getRank(filtered, index);
                  return (
                    <tr key={index} className={index < 3 ? "ranking" : ""}>
                      <td>{rank}</td>
                      <td>{player.playerNo}</td>
                      <td>{player.country}</td>
                      <td>{player.name}</td>
                      <td>{player.gender}</td>
                      <td>{player.percentileScores["145M"] || "-"}</td>
                      <td>{player.percentileScores["90M"] || "-"}</td>
                      <td>{player.percentileScores["70M"] || "-"}</td>
                      <td>{player.percentileScores["30M"] || "-"}</td>
                      <td>{player.total}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="table-gradient"></div>
        </div>
      </div>
    </>
  );
};
export default Personal;
